import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.validateInput()
  }

  focusInput() {
    setTimeout(() => this.inputTarget.focus(), 100)
  }

  validateInput() {
    const isValid = this.inputTarget.value.length >= 3
    this.submitTarget.disabled = !isValid
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  handleSubmit(event) {
    const modalId = event.target.dataset.modalId
    const modal = document.getElementById(modalId)
    
    if (modal) {
      const modalInstance = new Modal(modal)
      modalInstance.hide()
    }
  }

  afterSubmit(event) {
    this.inputTarget.value = ''
    this.validateInput()
  }
}
